<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Edit Approved Gifts</h1>
    </div>

    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link> /
      <b>Marketing</b> /
      <router-link :to="{ name: 'approved-gifts' }">Approved Gift</router-link> /
      <b>Details</b>
    </div>

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <div class="col-md-12 card mb-4">
        <div class="card-body">

          <form @submit.prevent="submitForm">
            <div class="col-6 mb-4">
              <img v-if="data.image" :src="data.image" class="img-fluid" /><br />

            </div>

            <div class="col-12 mb-4">
              <label><b>Company Name</b></label>
              <br />
              <label>{{ data.vendor_name }}</label>
            </div>

            <div class="col-12 mb-4">
              <label><b>Name</b></label>
              <br />
              <label>{{ data.name }}</label>
            </div>

            <div class="col-12 mb-4">
              <label>Expiry<b>(Note: This is the set period for users to redeem at the vendor counter, counted from the date the user selected the gift.)</b></label>
              <br />
              <label><b>{{ data.expiry }}</b></label>
            </div>

            <div class="col-12 mb-4">
              <label>Short Message</label>
              <textarea class="form-control" v-model="data.short_message"></textarea>
            </div>

            <div class="col-12 mb-4">
              <label>Long Message <b>(Note: This will appear after user select the gift under Birthday Rewards and Inbox details page)</b></label>
              <textarea class="form-control" v-model="data.long_message"></textarea>
            </div>

            <div class="col-12 mb-4">
              <label><b>Type</b></label>
              <div class="row">
                <label class="radio radio-gold ml-3">
                    <input type="radio" name="activeStatus" v-model="data.type" v-bind:value="a">
                    <span>General</span>
                    <span class="checkmark"></span>
                </label>
                <label class="radio radio-gold ml-3">
                    <input type="radio" name="activeStatus" @click="tierChecked" v-model="data.type"  v-bind:value="b">
                    <span>Tier</span>
                    <span class="checkmark"></span>
                </label>
              </div>

              <div class="row ml-5 pl-5" v-show="data.type == 2">
                <span v-for="(input, index) in checkBoxInputs" :key="index">
                  <input class="mr-2" type="checkbox" :id="`check_${input.value}`" v-model="data.tiers" :value="input.value">
                  <label class="mr-4" :for="`check_${input.value}`">{{ input. name }}</label>
                </span>
              </div>
            </div>

            <div class="float-left">
              <button
                type="submit"
                class="btn btn-primary btn-wide mt-4"
              >
                Submit 
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getGift, updateGifts } from "../../../services/GiftServices";

export default {
  data() {
    return {
      a: 1,
      b: 2,

      data: {
        short_message: '',
        long_message: '',
        image: '',
        type: 1,
        tiers: [],
      },

      checkBoxInputs: [
        {value: 1, name: 'Silver'},
        {value: 2, name: 'Gold'},
        {value: 3, name: 'Platinum'},
        {value: 4, name: 'Black'},
      ],

      imageUploaded: null,

    }
  },

  methods: {
    handleFileUpload() {
      this.data.upload = this.$refs.file.files[0];
      this.data.image_url = URL.createObjectURL(this.data.upload);
      this.imageUploaded = this.data.upload;
    },

    async fetchData() {
      this.id = this.$route.params.id;

      try {
        const response = await getGift(this.id);

        if(response.data.success) {
          this.data = response.data.data;
        }

        if(this.data.tier_array != null) {
          this.data.tiers = this.data.tier_array;
        }

      } catch (e) {
        console.error(e);
      }
    },

    async submitForm() {
      try {
        if(this.data.type == 1) {
          this.data.tiers = null;
        }

        const response = await updateGifts(this.data, this.id);

        swal({
          icon: response.data.success ? 'success' : 'error',
          text: response.data.message
        });
      } catch (e) {
        console.error(e)
      }
    },

    tierChecked() {
      if(this.data.hasOwnProperty("tiers") == false) {
        this.data.tiers = [];
      }
    }
  },

  async mounted() {
    await this.fetchData();
  },
}

</script>

<style scoped>
input[type="file"]::file-selector-button {
  margin-right: 20px;
  border: none;
  padding: 10px 20px;
  border-radius: 10px;
  color: #fff;
  background-color: #AC8400;
  border-color: #AC8400;

  /* cursor: pointer; */
  transition: background 0.2s ease-in-out;
}

input[type="file"]::file-selector-button:hover {
  color: #fff;
    background-color: #806200;
    border-color: #b38900;
}

/* Hide the default checkbox */
input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom checkbox */
input[type="checkbox"] + label {
  position: relative;
  padding-left: 25px;
  cursor: pointer;
  font-size: 14px;
}

/* Custom checkbox square */
input[type="checkbox"] + label::before {
  content: '';
  position: absolute;
  left: 0;
  top: 3px;
  width: 18px;
  height: 18px;
  border: 2px solid #ccc;
  background-color: white;
  border-radius: 3px;
}

/* Tick mark */
input[type="checkbox"]:checked + label::after {
  content: '';
  position: absolute;
  left: 5px;
  top: 5px;
  width: 6px;
  height: 12px;
  border: solid #AC8400;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
</style>
